import React, { Component } from "react";
import "./style.scss";

// remove extra css

class ItemEmpty extends Component {
  render() {
    const { children } = this.props;

    return (
      <li className="itemComp itemEmptyComp bg-transparent">
        {!children ? (
          <p className="itemComp__text text-center text-primary m-0 itemEmptyComp__text">
            اطلاعـاتـی جهت نمـایش مـوجـود نیست.
          </p>
        ) : (
          children
        )}
      </li>
    );
  }
}

export { ItemEmpty };
